<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-route`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M22 30v-9H11.216a1 1 0 01-.75-1.662L23.25 4.85a1 1 0 011.5 0l12.784 14.488a1 1 0 01-.75 1.662H26v12a1 1 0 01-1 1H14v10h-4V31a1 1 0 011-1h11zm2-19.954L17.864 17h12.272L24 10.046z"/></svg>
</template>
<script>

export default {
  name: 'IconRoute',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
